import { KeyboardEvent, MouseEvent, useCallback, useEffect, useRef, useState } from "react"
import Actionbar from "src/components/common/actionbar/Authactionbar"
import { Message } from "src/components/common/form/Message"
import useUiuxStore from "src/store/useUiuxStore"

import { AgGridReact } from "ag-grid-react"
import { InsertRowHandler } from "src/utils/grid/GridHandlerContent"
import { PRD1010_R01Content } from "./Content_PRD1010_R01"
import { defaultPRD1010_R01Dto, PRD1010_R01Dto } from "./Dto_PRD1010_R01"
import { PRD1010_R01SearchSection } from "./SearchSection_PRD1010_R01"
import { usePRD1010_R01Store } from "./Store_PRD1010_R01"
import { PRD1010_R01Table } from "./Table_PRD1010_R01"

/**
 * 사용자 관리 컨테이너 컴포넌트
 * 사용자 관리 화면의 전체 레이아웃과 상태 관리를 담당
 */
export const Container_PRD1010_R01 = () => {
	

	const { 
		PRD1010_R01List,
		insertPRD1010_R01List,
		removePRD1010_R01List,
		addDeletedPRD1010_R01List,
		allCount,
		initData 
	} = usePRD1010_R01Store();
	const { setMessage } = useUiuxStore();

	

	const gridRef = useRef<AgGridReact<PRD1010_R01Dto>>(null);

	// UserContent에서 필요한 핸들러 함수들을 가져옴
	const {
		clickable, setClickable,
		fetchData,
		defaultPRD1010_R01Row,
		initContainerData,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		handlePrintClick,
		buttonDisabled
	} = PRD1010_R01Content({
		gridRef,
		setMessage,
		
	});

	useEffect(() => { 
		if (PRD1010_R01List.length === 0) { handleInsertClick({} as MouseEvent<HTMLButtonElement>); }
	}, [PRD1010_R01List, handleInsertClick]);

	return <div className="content-container">
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleInsertClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onExcelClick={handleExcelClick}
			onPrintClick={handlePrintClick}
			onInitClick={initContainerData}
		/>
		
		<PRD1010_R01SearchSection 
			onEnterKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
				if (e.key === 'Enter') {
					fetchData()
				}
			}} 
		/>
		<div className="flex-1 flex">
			<div className="w-full h-full flex flex-col  p-[12px] gap-[12px]">
				
				<PRD1010_R01Table 
					clickable={clickable}				setClickable={setClickable}
					gridRef={gridRef}
					defaultPRD1010_R01Row={defaultPRD1010_R01Row()}
				/>
			</div>
		</div>
		{/* 메시지 표시 컴포넌트 */}
		<Message />
	</div>
}